/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tb_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decoding fails if the input contains characters other than 0 and 1, if the total number of bits is not a multiple of eight, or if the bytes do not form valid UTF-8. The error message names which rule was broken so you can fix the input.`)
};

const es_tb_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La decodificación falla si la entrada contiene caracteres distintos de 0 y 1, si el número total de bits no es un múltiplo de ocho, o si los bytes no forman UTF-8 válido. El mensaje de error indica qué regla se incumplió para que puedas corregir la entrada.`)
};

const de_tb_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Dekodieren schlägt fehl, wenn die Eingabe andere Zeichen als 0 und 1 enthält, wenn die Gesamtzahl der Bits kein Vielfaches von acht ist oder wenn die Bytes kein gültiges UTF-8 ergeben. Die Fehlermeldung nennt, welche Regel verletzt wurde, damit du die Eingabe korrigieren kannst.`)
};

const nl_tb_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decodering mislukt als de invoer tekens bevat anders dan 0 en 1, als het totale aantal bits geen veelvoud van acht is, of als de bytes geen geldige UTF-8 vormen. Het foutbericht geeft aan welke regel is overtreden zodat je de invoer kunt corrigeren.`)
};

const fr_tb_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le décodage échoue si l'entrée contient des caractères autres que 0 et 1, si le nombre total de bits n'est pas un multiple de huit, ou si les octets ne forment pas un UTF-8 valide. Le message d'erreur indique quelle règle a été violée pour que vous puissiez corriger l'entrée.`)
};

const it_tb_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La decodifica non funziona se l'input contiene caratteri diversi da 0 e 1, se il numero totale di bit non è un multiplo di otto, o se i byte non formano un UTF-8 valido. Il messaggio di errore indica quale regola è stata violata in modo che tu possa correggere l'input.`)
};

const pt_br2_tb_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A decodificação falha se a entrada contiver caracteres diferentes de 0 e 1, se o número total de bits não for um múltiplo de oito, ou se os bytes não formarem UTF-8 válido. A mensagem de erro indica qual regra foi violada para que você possa corrigir a entrada.`)
};

const pt_tb_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A descodificação falha se a entrada contiver caracteres diferentes de 0 e 1, se o número total de bits não for um múltiplo de oito, ou se os bytes não formarem UTF-8 válido. A mensagem de erro nomeia qual regra foi quebrada para que possa corrigir a entrada.`)
};

const ja_tb_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入力に 0 と 1 以外の文字が含まれている場合、ビット数が 8 の倍数ではない場合、またはバイトが有効な UTF-8 を形成しない場合、デコードは失敗します。エラー メッセージは、入力を修正できるように、どのルールが破られたかを示します。`)
};

const zh_tb_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果输入内容包含0和1以外的字符、二进制位总数不是八的倍数,或者字节无法构成有效的UTF-8,解码就会失败。错误信息会说明具体违反了哪条规则,方便您修正输入内容。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tb_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tb_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tb_faq4_a", locale)
	if (locale === "en") return en_tb_faq4_a(inputs)
	if (locale === "es") return es_tb_faq4_a(inputs)
	if (locale === "de") return de_tb_faq4_a(inputs)
	if (locale === "nl") return nl_tb_faq4_a(inputs)
	if (locale === "fr") return fr_tb_faq4_a(inputs)
	if (locale === "it") return it_tb_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_tb_faq4_a(inputs)
	if (locale === "pt") return pt_tb_faq4_a(inputs)
	if (locale === "ja") return ja_tb_faq4_a(inputs)
	return zh_tb_faq4_a(inputs)
};